module.exports = __webpack_public_path__ + "static/img/wgt-around-service.a3e2d021.png";